import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import {
  InventoryProductItem,
  InventoryProductState
} from '@/modules/inventory/inventoryProduct/types/types.ts'

const initialState: InventoryProductState = {
  selected: undefined,
  isDeleteModalOpen: false,
  isOpenModal: false
}

const inventoryProductSlice = createSlice({
  name: 'inventoryProducts',
  initialState,
  reducers: {
    setSelected: (
      state,
      action: PayloadAction<InventoryProductItem | undefined>
    ) => {
      state.selected = action.payload
    },
    setOpenModal: (state, action: PayloadAction<boolean>) => {
      state.isOpenModal = action.payload
    },
    setDeleteOpenModal: (state, action: PayloadAction<boolean>) => {
      state.isDeleteModalOpen = action.payload
    }
  }
})

export const inventoryProductsActions = inventoryProductSlice.actions
export const { reducer: inventoryProductsReducer } = inventoryProductSlice
